import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { MSAL_INSTANCE } from './constants';
import { EventMessage, EventMessageUtils, InteractionStatus, IPublicClientApplication } from '@azure/msal-browser';

@Injectable()
export class MsalBroadcastService {
  private _msalSubject: Subject<any>;
  public msalSubject$: Observable<any>;

  private _inProgress: BehaviorSubject<InteractionStatus>;
  public inProgress$: Observable<InteractionStatus>;

  constructor(
    @Inject(MSAL_INSTANCE) private msalInstance: IPublicClientApplication
  ) {
    this._msalSubject = new Subject<EventMessage>();
    this.msalSubject$  = this._msalSubject.asObservable();    
    
    // InProgress as BehaviorSubject so most recent inProgress state will be available upon subscription
     this._inProgress = new BehaviorSubject<InteractionStatus>(InteractionStatus.Startup);
     this.inProgress$ = this._inProgress.asObservable();


     this.msalInstance.addEventCallback((message: EventMessage) => {
        this._msalSubject.next(message);
      });


      this.msalInstance.addEventCallback((message: EventMessage) => {
        this._msalSubject.next(message);
        const status = EventMessageUtils.getInteractionStatusFromEvent(message, this._inProgress.value);
        if (status !== null) {
            this.msalInstance.getLogger().verbose(`BroadcastService - ${message.eventType} results in setting inProgress from ${this._inProgress.value} to ${status}`);
            this._inProgress.next(status);
        }
    });

  }

}